<div class="table-top-container clearfix">	
	<div class="top-left-container">
		<!-- Show/Hide button -->
		@if (canShowHideColumns) { <pcg-button-hide-show [columnDefs]="columnDefs"></pcg-button-hide-show> }

        <!-- Color Legend -->
        @if (legend?.length > 0) {
            <s2-table-top-legend             
                class="hidden-sm mr-2"
                [legendVms]="legend"
            ></s2-table-top-legend>
        }

		<!-- Apply Filters button -->
		@if (filterId) {
            <pcg-button-filter 		 
                id="pcg-button-filter" 
                [filterId]="filterId"
            ></pcg-button-filter>
        }

		<!-- Reset Filters button -->
		@if (showResetFilterBtn()) { <pcg-button-reset-filter></pcg-button-reset-filter> }

		<!-- Units/Vials/Vol toggle -->
		@if (canToggleUnits) {
            <mat-button-toggle-group 		
                #vialToggleBtn="matButtonToggleGroup" 
                class="vial-unit-toggle" 
                [value]="unitType" 
            >
                <mat-button-toggle 
                    (click)="setUnitType(unitTypeEnum.Units)" 
                    [value]="unitTypeEnum.Units"
                >Units</mat-button-toggle>
                <mat-button-toggle 
                    (click)="setUnitType(unitTypeEnum.Vials)" 
                    [value]="unitTypeEnum.Vials"
                >Vials</mat-button-toggle>
                <mat-button-toggle 
                    (click)="setUnitType(unitTypeEnum.Volume)" 
                    [value]="unitTypeEnum.Volume"
                >Volume</mat-button-toggle>
            </mat-button-toggle-group>
        }

		<!-- Inventory Types toggle -->
		@if (canToggleInventoryTypes) {
            <mat-button-toggle-group		
                #inventoryTypeToggleBtn="matButtonToggleGroup" 
                class="vial-unit-toggle" 
                [value]="inventoryType"
            >
                <mat-button-toggle 
                    (click)="filterSource.next(null)" 
                    [value]="null"
                >All</mat-button-toggle>
                <mat-button-toggle 
                    (click)="filterSource.next('Truck')" 
                    [value]="inventoryTypeEnum.Truck"
                >{{ gvs.clientTruckName() }}</mat-button-toggle>
                <mat-button-toggle 
                    (click)="filterSource.next('Station')" 
                    [value]="inventoryTypeEnum.Station"
                >{{ gvs.clientStationName() }}</mat-button-toggle>
                <mat-button-toggle 
                    (click)="filterSource.next('Quarantine')" 
                    [value]="inventoryTypeEnum.Quarantine"
                >Quarantines</mat-button-toggle>
            </mat-button-toggle-group>
        }

		<!-- User Permissions toggle -->
		@if (canToggleUserPermissions) {
            <!--
                S2N-3076: these values are Permissions ROW IDS (PermissionRowIds), never ranks and
                never InventoryType - the [value] bindings were copied from the inventory toggle
                above and named the wrong enum. View Only is deliberately NOT an option: this toggle
                only ever filters a user-association picker, and a View Only user holds no inventory
                or department associations by design (DefaultInventoryClass() == None).
            -->
            <mat-button-toggle-group
                #userPermissionToggleBtn="matButtonToggleGroup"
                class="vial-unit-toggle"
                [value]="permissionRowId"
            >
                <mat-button-toggle
                    (click)="setPermissionLevel(null)"
                    [value]="null"
                >All</mat-button-toggle>
                <mat-button-toggle
                    (click)="setPermissionLevel(permissionRowIds.provider)"
                    [value]="permissionRowIds.provider"
                >Providers</mat-button-toggle>
                <mat-button-toggle
                    (click)="setPermissionLevel(permissionRowIds.witness)"
                    [value]="permissionRowIds.witness"
                >Witnesses</mat-button-toggle>
                <mat-button-toggle
                    (click)="setPermissionLevel(permissionRowIds.manager)"
                    [value]="permissionRowIds.manager"
                >Managers</mat-button-toggle>
                <mat-button-toggle
                    (click)="setPermissionLevel(permissionRowIds.admin)"
                    [value]="permissionRowIds.admin"
                >Admins</mat-button-toggle>
            </mat-button-toggle-group>
        }

        <!-- Department Filter -->
         @if (canToggleDepartments) {
            <div>
                <select
                    (change)="setDepartmentId($event.target.value)" 
                    class="html-select"
                >
                    <option [value]="null" selected>Select A Department</option>
                    @for (department of departments; track department) {
                        <option [value]="department.value">{{ department.text }}</option>
                    }
                </select>
            </div>
        }

		<!-- Applied Filters -->
		@if (
            filterMap() != null
            && btnFilterService.getActiveFilters(ajaxData, filterMap())
        ) {
            <div class="applied-filters" >
                Applied Filters: {{ btnFilterService.getActiveFilters(ajaxData, filterMap()) }}
            </div>
        }
	</div>	
	
	<div class="top-right-container">
		<div class="table-actions">
			<!-- Tiles/List toggle -->
			@if (
                !isMobile() 
                && showTilesBtn
            ) {
                <mat-button-toggle-group class="vial-unit-toggle">
                    <mat-button-toggle (click)="tableViewClick(true)">
                        <fa-icon 
                            [icon]="faIconName.faTableCellsLarge" 
                            class="table-action-icon"							
                        ></fa-icon>
                    </mat-button-toggle>

                    <mat-button-toggle (click)="tableViewClick(false)">
                        <fa-icon 
                            [icon]="faIconName.faTableList" 
                            class="table-action-icon"
                        ></fa-icon>
                    </mat-button-toggle>
                </mat-button-toggle-group>
            }

			<!-- Column tooltips button -->
			@if (
                hasTooltips 
                && (
                    isMobile() 
                    || showTooltipsBtn
                )
            ) {
                <button 
                    (click)="tooltipButtonClicked()" 
                    class="table-action-tooltip-btn" 					
                >
                    <fa-icon 
                        [icon]="faIconName.faQuestion" 
                        class="table-action-tooltip-icon invert-color"
                    ></fa-icon>
                </button>
            }

			<!-- Excel button -->
			@if (canExportTableToExcel) {
                <button 
                    ngbTooltip="Export to Excel" 
                    (click)="table.getExcel()" 
                    class="table-action-btn"
                >
                    <fa-icon 
                        [icon]="faIconName.faFileExcel" 
                        class="table-action-icon fa-lg"
                        style="color: green;"
                    ></fa-icon>
                </button>
            }

			<!-- Print button -->
			@if (canPrintTable) {
                <button 			
                    ngbTooltip="Print the Report" 
                    (click)="table.print()" 
                    class="table-action-btn" 					
                >
                    <fa-icon 
                        [icon]="faIconName.faPrint" 
                        class="table-action-icon fa-lg"
                        style="color: #2980B9;"
                    ></fa-icon>
                </button>
            }
		</div>		

		<!-- Table search -->
		@if (canGlobalSearch) {
            <div class="search-container">
                <input
                    aria-label="Table search"
                    type="search"
                    class="form-control form-control-sm tt-search"
                    placeholder="Search..."
                    (input)="filterSource.next($event.target.value)"
                    (click)="clearSearch($event)"
                />
            </div>
        }
	</div>

	<!-- Column tooltip modal -->
	<ng-template 
		#tooltipModal 
		let-modal
	>
		<div class="modal-header">
			<h5>Column Tooltips</h5>
			<button 
				type="button" 
				class="close" 
				aria-label="Close" 
				(click)="modal.dismiss()"
			><span aria-hidden="true">&times;</span></button>
		</div>

		<div class="modal-body flex-body">
			<pcg-table-top-tooltip *ngTemplateOutlet="tooltipContent"></pcg-table-top-tooltip>
		</div>
	</ng-template>
</div>